import { formatGenericRequestPayload, formatStateParamsToData } from '../../utils';

export default class ResultsController {
  /* @ngInject */
  constructor(ConfigurationService, ExpertService, DataService,
    $stateParams, $anchorScroll, NavigationService, $log,
    ProductLinkService) {
    this.authorable = ConfigurationService.getConfiguration();
    this.$anchorScroll = $anchorScroll;
    this.DataService = DataService;
    this.DataService.extendData(formatStateParamsToData($stateParams));
    this.NavigationService = NavigationService;
    this.searchLinkIsFromProductPage = ProductLinkService.getProductLinkVerification();
    this.$log = $log;
    let localData = {};
    if (this.searchLinkIsFromProductPage) {
      localData.solutions = {};
      ProductLinkService.getSearchParams()
        .forEach((solution) => {
          localData.solutions[solution] = true;
        });
    } else {
      localData = this.DataService.getData();
    }
    const payload = formatGenericRequestPayload(localData);

    this.searchSummary = localData;
    this.currentSelectedExpertType = '';
    this.orderByLocationFilterValue = false;
    this.selectedIndustry = this.DataService.data.myIndustry;
    this.industryFilterValue = false;
    this.resultsToShowPerPage = parseInt(this.authorable.results_resultsToShowPerPage, 10);

    ExpertService
      .getExperts(payload)
      .then((data) => {
        this.experts = data;
        this.filteredExperts = data;
        this.expertHasGeolocationData(this.experts);
      });
  }

  $onInit() {
    this.$anchorScroll();
    this.paginationCurrentPage = 0;
  }

  navigateToSearch() {
    this.DataService.clearSolutions();
    this.NavigationService.navigateToSearchScreen();
  }

  sortByFilter(filter, value) {
    // reset pagination everytime the filter changes
    this.resetPagination();
    this.filters = {
      orderby: () => this.orderByLocationFilter(value),
      expertType: () => this.showByExpertTypeFilter(value),
      industry: () => this.showByIndustryFilter(value)
    };
    this.filters[filter]();
  }

  orderByLocationFilter(value) {
    this.orderByLocationFilterValue = !!value;
  }

  showByExpertTypeFilter(value) {
    this.currentSelectedExpertType = value;
    this.filterReturnedExperts('expertType', value);
  }

  showByIndustryFilter(value) {
    this.industryFilterValue = value;
    this.filterReturnedExperts('industry', value);
  }

  filterReturnedExperts() {
    this.filteredExperts = this.experts;
    if (this.industryFilterValue) {
      this.filteredExperts = this.experts
        .filter(val => val.industries.includes(this.selectedIndustry));
    }
    if (this.currentSelectedExpertType) {
      this.filteredExperts = this.filteredExperts.filter(val => val.expertType === this.currentSelectedExpertType || val.expertType === 'TBC');
    }
  }

  expertHasGeolocationData(expertData) {
    // if there is no distanceFromUserPostcode data then we do not want to show the location filter
    this.showLocationFilter = expertData
      .some(expert => angular.isDefined(expert.distanceFromUserPostcode));
  }

  resetPagination() {
    this.updatePaginationCurrentPage(0);
  }

  updatePaginationCurrentPage(pageNumber) {
    this.paginationCurrentPage = pageNumber;
    this.$anchorScroll();
  }

  showResultsByPagination(index) {
    return this.experts.length > 0
      && (index >= this.paginationCurrentPage * this.resultsToShowPerPage)
      && (index < ((this.paginationCurrentPage + 1) * this.resultsToShowPerPage));
  }

  setFirstResultToHaveBorderTop(index) {
    if (index === 0 || index === this.paginationCurrentPage * this.resultsToShowPerPage) {
      return 'first-result';
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/containers/results/results.controller.js